'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useReducedMotion } from 'motion/react';

/**
 * Counts 0..steps-1 on a loop so mock screens can "play" a short story.
 * Holds on the final step when the user prefers reduced motion.
 */
export function useTicker(steps, t0) {
  const $ = _c(5);
  const intervalMs = t0 === undefined ? 1100 : t0;
  const reduceMotion = useReducedMotion();
  const [tick, setTick] = useState(0);
  let t1;
  let t2;
  if ($[0] !== intervalMs || $[1] !== reduceMotion || $[2] !== steps) {
    t1 = () => {
      if (reduceMotion) {
        return;
      }
      const id = setInterval(() => setTick(t => (t + 1) % steps), intervalMs);
      return () => clearInterval(id);
    };
    t2 = [steps, intervalMs, reduceMotion];
    $[0] = intervalMs;
    $[1] = reduceMotion;
    $[2] = steps;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return reduceMotion ? steps - 1 : tick;
}